export const products = [
  {
    id: 1,
    name: "TMT Bars",
    category: "Reinforcement Steel",
    description: "High-strength TMT bars for construction, available in various grades (Fe 415, Fe 500, Fe 550)",
    grades: ["Fe 415", "Fe 500", "Fe 550"],
    sizes: ["8mm", "10mm", "12mm", "16mm", "20mm", "25mm", "32mm"],
    image: "https://images.pexels.com/photos/46167/iron-rods-reinforcing-bars-rods-steel-bars-46167.jpeg"
  },
  {
    id: 2,
    name: "Round Bars",
    category: "Round Steel",
    description: "Premium quality round bars in all sizes for diverse industrial and construction applications. Available in mild steel and alloy steel grades.",
    grades: ["Mild Steel", "EN Series", "Alloy Steel"],
    sizes: ["6mm", "8mm", "10mm", "12mm", "16mm", "20mm", "25mm", "32mm", "40mm", "50mm", "and all other sizes"],
    image: "https://images.pexels.com/photos/32845680/pexels-photo-32845680.jpeg"
  },
  {
    id: 3,
    name: "Flat Bars",
    category: "Flat Products",
    description: "High-quality flat bars for various industrial and construction applications. Available in different widths and thicknesses.",
    grades: ["Mild Steel", "High Tensile Steel"],
    sizes: ["20mm x 3mm", "25mm x 5mm", "40mm x 6mm", "50mm x 8mm", "75mm x 10mm", "100mm x 12mm"],
    image: "https://images.unsplash.com/photo-1676310149114-3f6310957ca6?w=800&q=80"
  },
  {
    id: 4,
    name: "Structural Steel",
    category: "Structural",
    description: "I-beams, H-beams, and steel sections for heavy construction and infrastructure projects",
    types: ["I-Beams", "H-Beams", "Wide Flange", "Universal Beams"],
    image: "https://images.pexels.com/photos/53176/architecture-iron-steel-building-53176.jpeg"
  },
  {
    id: 8,
    name: "Steel Sheets & Plates",
    category: "Flat Products",
    description: "Hot-rolled and cold-rolled steel sheets and plates in various thicknesses",
    types: ["Hot Rolled", "Cold Rolled", "Galvanized", "Stainless Steel"],
    thickness: ["1mm to 100mm"],
    image: "https://images.unsplash.com/photo-1676310149114-3f6310957ca6?w=800&q=80"
  },
  {
    id: 5,
    name: "Steel Coils",
    category: "Flat Products",
    description: "High-quality steel coils for manufacturing and fabrication industries",
    types: ["HR Coils", "CR Coils", "GP Coils", "GC Coils"],
    image: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?w=800&q=80"
  },
  {
    id: 6,
    name: "Steel Pipes & Tubes",
    category: "Hollow Sections",
    description: "Seamless and welded pipes for various industrial applications",
    types: ["ERW Pipes", "Seamless Pipes", "MS Pipes", "GI Pipes"],
    sizes: ["1/2 inch to 24 inch"],
    image: "https://images.unsplash.com/photo-1649706286480-1c6f3f3c1fb1?w=800&q=80"
  },
  {
    id: 7,
    name: "Angles & Channels",
    category: "Structural",
    description: "Steel angles and channels for framework and support structures",
    types: ["Equal Angles", "Unequal Angles", "C Channels", "U Channels"],
    image: "https://images.unsplash.com/photo-1651890318280-c5e35ef92f85?w=800&q=80"
  }
];

export const services = [
  {
    id: 1,
    title: "Bulk Steel Supply",
    description: "Large volume supply for construction projects and industrial applications",
    icon: "Boxes"
  },
  {
    id: 2,
    title: "Custom Cutting & Fabrication",
    description: "Precision cutting and fabrication services as per your specifications",
    icon: "Scissors"
  },
  {
    id: 3,
    title: "Quality Testing",
    description: "Complete quality assurance with mill test certificates and third-party testing",
    icon: "ClipboardCheck"
  },
  {
    id: 4,
    title: "Timely Delivery",
    description: "Pan-India delivery network ensuring on-time delivery to your site",
    icon: "Truck"
  },
  {
    id: 5,
    title: "Technical Consultation",
    description: "Expert guidance on material selection and specifications",
    icon: "Users"
  },
  {
    id: 6,
    title: "Competitive Pricing",
    description: "Best market rates with transparent pricing and bulk discounts",
    icon: "IndianRupee"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    company: "Metro Construction Ltd.",
    role: "Project Manager",
    content: "G.A ISPAT has been our trusted partner for multiple years. Their quality TMT bars and structural steel have never disappointed us.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    company: "Industrial Fabricators Inc.",
    role: "Procurement Head",
    content: "Excellent quality steel products with competitive pricing. Their technical support team is very knowledgeable and helpful.",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Patel",
    company: "Skyline Developers",
    role: "Director",
    content: "Reliable supplier with consistent quality. They understand project timelines and deliver accordingly. Highly recommended!",
    rating: 5
  }
];

export const stats = [
  { label: "Years in Business", value: "18+", icon: "Calendar" },
  { label: "Happy Clients", value: "500+", icon: "Users" },
  { label: "Projects Completed", value: "1000+", icon: "Building2" },
  { label: "Tonnes Supplied", value: "50K+", icon: "Weight" }
];

export const categories = [
  { name: "All Products", value: "all" },
  { name: "Reinforcement Steel", value: "Reinforcement Steel" },
  { name: "Round Steel", value: "Round Steel" },
  { name: "Structural", value: "Structural" },
  { name: "Flat Products", value: "Flat Products" },
  { name: "Hollow Sections", value: "Hollow Sections" }
];

export const founders = [
  {
    id: 1,
    name: "Ravinder Kumar Garg",
    designation: "Founder",
    image: "/images/founder-ravinder-garg.jpeg",
    description: "Ravinder Garg is the Founder of G.A Ispat Pvt Ltd, a steel trading enterprise built from the ground up through vision, discipline, and decades of perseverance. With over 40 years of experience in the steel industry, he has played a pivotal role in establishing the company as a trusted and reliable partner within the trading and infrastructure ecosystem. Starting his journey from modest beginnings, he built the business brick by brick, guided by strong values of integrity, commitment, and long-term relationships. His deep understanding of market cycles, supply chain dynamics, and customer requirements has enabled the company to navigate industry shifts while maintaining stability and credibility. Known for his low-profile and grounded leadership style, he believes in letting performance and reputation speak louder than words. Under his stewardship, the company has grown steadily through trust-based partnerships, financial prudence, and consistent quality delivery rather than aggressive expansion. Even after four decades, he remains closely involved in key business decisions, mentoring the next generation and ensuring that the company's foundational principles of honesty, reliability, and resilience continue to guide its future growth."
  },
  {
    id: 2,
    name: "Vineet Garg",
    designation: "Managing Director",
    image: "/images/founder-vineet-garg.jpeg",
    description: "Vineet Garg is an Indian business leader and serves as the Founder and Managing Director of G.A Ispat Pvt Ltd since October 2020. He is responsible for overseeing the overall strategic direction of the company, including operations management, business development, financial planning, and supplier relationship management. Under his leadership, the company focuses on strengthening its presence in the steel and infrastructure ecosystem through operational discipline, quality assurance, and long-term partnerships. Vineet Garg is actively driving sustainable growth and structured expansion of the business, with emphasis on supply chain efficiency, customer-centric execution, and scalable systems. His approach integrates modern management practices with the foundational strengths of a traditional industrial enterprise. Prior to leading G.A Ispat Pvt Ltd, he was associated with Times Strategic Solutions Limited, where he gained experience in strategic sales and corporate solutions. He has also worked in account planning and marketing roles, building a strong foundation in brand communication and analytical decision-making. Vineet Garg holds a Master of Business Administration (MBA) from Symbiosis International University, Pune and a Bachelor of Business Administration (BBA) in Marketing from J.D. Birla Institute, Kolkata."
  }
];

export const partners = [
  {
    id: 1,
    name: "Tata Steel",
    type: "Authorized Dealer & Supplier",
    logo: "https://logos-world.net/wp-content/uploads/2023/02/Tata-Steel-Logo.png"
  },
  {
    id: 2,
    name: "JSW Steel",
    type: "Authorized Dealer & Supplier",
    logo: "https://logos-world.net/wp-content/uploads/2022/04/JSW-Steel-Logo.png"
  },
  {
    id: 3,
    name: "SAIL",
    type: "Authorized Dealer & Supplier",
    logo: "https://logos-world.net/wp-content/uploads/2023/02/SAIL-Logo.png"
  },
  {
    id: 4,
    name: "Shyam Steel",
    type: "Authorized Dealer & Supplier",
    logo: "https://shyamsteel.com/wp-content/themes/shyamsteel/assets/images/logo.svg"
  },
  {
    id: 5,
    name: "Jindal Steel",
    type: "Authorized Dealer & Supplier",
    logo: "https://logos-world.net/wp-content/uploads/2023/02/Jindal-Steel-Power-Logo.png"
  }
];

export const newsArticles = [
  {
    id: 1,
    title: "Steel Prices Set to Rise ₹2,000/Tonne in September on Firm Demand",
    category: "Market Update",
    date: "2026-09-12",
    excerpt: "Mills announce price hikes of ₹1,500-2,000 per tonne for September as post-monsoon construction demand surges. Tighter supply after annual maintenance shutdowns and rising coking coal costs push TMT and rebar prices higher across India.",
    image: "https://images.unsplash.com/photo-1651890318280-c5e35ef92f85?w=800&q=80",
    source: "The Hindu BusinessLine"
  },
  {
    id: 2,
    title: "Long Steel Rally Has Room to Run, Say Analysts; Jindal & JSW Top Picks",
    category: "Stock Market",
    date: "2026-09-08",
    excerpt: "Axis Capital says the long-steel and rebar rally has further upside. Jindal Steel named preferred tactical bet on its long-product exposure, while JSW Steel remains the top structural pick on strong volume growth. SAIL also in focus despite wage revision headwinds.",
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&q=80",
    source: "CNBC-TV18"
  },
  {
    id: 3,
    title: "Kolkata Steel Market Gears Up for Festive Season Demand Surge",
    category: "Market Update",
    date: "2026-09-04",
    excerpt: "Burrabazar traders stock up ahead of the festive construction rush. TMT bars, round bars and structural steel see brisk enquiries as Eastern India infrastructure and housing projects accelerate after the monsoon.",
    image: "https://images.pexels.com/photos/46167/iron-rods-reinforcing-bars-rods-steel-bars-46167.jpeg?w=800&q=80",
    source: "Steel Insights India"
  },
  {
    id: 4,
    title: "TMT Bar Prices Rebound to ₹58,000/Tonne in August, Up 6% YoY",
    category: "Market Update",
    date: "2026-08-28",
    excerpt: "Average 10mm TMT bar prices touch ₹58,000 per tonne in August 2026, a 5.8-6% year-on-year rise. Robust post-monsoon recovery in infrastructure, construction and manufacturing drives the rebound; analysts expect further hikes in September.",
    image: "https://images.pexels.com/photos/46167/iron-rods-reinforcing-bars-rods-steel-bars-46167.jpeg?w=800&q=80",
    source: "The Hindu BusinessLine"
  },
  {
    id: 5,
    title: "India's Finished Steel Consumption Grows 8% in April-July FY27",
    category: "Industry News",
    date: "2026-08-22",
    excerpt: "Steel output rises 4.7% while demand grows nearly 8% during April-July 2026. Government infrastructure push and housing demand keep consumption strong; steel demand projected to grow at 7% CAGR between FY26 and FY29.",
    image: "https://images.pexels.com/photos/53176/architecture-iron-steel-building-53176.jpeg?w=800&q=80",
    source: "News18 Business"
  },
  {
    id: 6,
    title: "Tata Steel Commissions ₹3,200 Crore Scrap-Based EAF Plant in Ludhiana",
    category: "Industry News",
    date: "2026-08-18",
    excerpt: "Tata Steel's new electric arc furnace plant in Ludhiana begins production, using recycled scrap to make greener steel. The 0.75 MTPA facility strengthens the company's low-carbon steel portfolio and North India presence.",
    image: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?w=800&q=80",
    source: "PIB / Business Standard"
  },
  {
    id: 7,
    title: "Coking Coal Costs Rise; Mills Pass on Input Pressure to Steel Prices",
    category: "Global Market",
    date: "2026-08-12",
    excerpt: "Rising coking coal prices and annual maintenance shutdowns tighten supply across Indian mills. Long products including TMT and rebar lead the price recovery as input cost pressure builds through Q2 FY27.",
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&q=80",
    source: "Economic Times"
  },
  {
    id: 8,
    title: "Nomura Maintains 'Buy' on Tata Steel and JSW Steel; Picks Jindal Steel",
    category: "Stock Market",
    date: "2026-08-08",
    excerpt: "Nomura names Jindal Steel its preferred tactical bet in Indian steel while maintaining Buy ratings on Tata Steel and JSW Steel, citing strong rebar demand, capacity expansions and a favourable pricing cycle.",
    image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&q=80",
    source: "Moneycontrol"
  },
  {
    id: 9,
    title: "Structural Steel Demand Strong as Metro & Highway Projects Accelerate",
    category: "Market Update",
    date: "2026-08-05",
    excerpt: "Structural steel consumption stays elevated on the back of metro rail, highway and port projects across India. Angles, channels and beams see steady offtake; Eastern region dealers report healthy order books into the festive quarter.",
    image: "https://images.pexels.com/photos/53176/architecture-iron-steel-building-53176.jpeg?w=800&q=80",
    source: "Construction Weekly"
  },
  {
    id: 10,
    title: "Indian Steel Sector Maintains Growth Momentum Into H2 2026",
    category: "Industry News",
    date: "2026-08-01",
    excerpt: "IBEF reports sustained growth momentum for Indian steel with rising capacity utilisation, healthy exports and strong domestic demand. India cements its position as the world's fastest-growing major steel market.",
    image: "https://images.unsplash.com/photo-1676310149114-3f6310957ca6?w=800&q=80",
    source: "IBEF"
  }
];
